<template>
  <div
    class="main--text">
    <v-card class="elevation-12">
      <v-card-text
        class="font-weight-bold red--text"
        v-show="errorMessage">{{errorMessage}}
      </v-card-text>
      <v-card-text>
        <v-form>
          <v-text-field
          v-model="email"
          prepend-icon="person"
          name="login"
          label="メールアドレス"
          type="text"
          v-validate="'required|email'"
          data-vv-name="email"
          data-vv-as="メールアドレス"
          required
          :error-messages="errors.collect('email')"
          >
          </v-text-field>
          <v-text-field
          v-model="password"
          prepend-icon="lock"
          name="password"
          label="パスワード"
          type="password"
          v-validate="'required|min:4|max:12|alpha_num'"
          data-vv-name="password"
          data-vv-as="パスワード"
          required
          :error-messages="errors.collect('password')"
          >
          </v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
        depressed
        rounded
        outlined
        color="primary"
        @click='main()'
        >ログイン
        </v-btn>
      </v-card-actions>
      <v-card-actions>
        <span
          class="caption clickable--text"
          @click="passwordDialog=true"
          >パスワードをお忘れの方
        </span>
      </v-card-actions>
    </v-card>
    <v-dialog
      :value="dialog"
      persistent
      width="350">
      <v-card>
        <v-container
          fluid>
          <v-row
            align="center">
            <v-col
              font-weight-bold
            >新規ユーザー情報登録に進んでください。
            </v-col>
          </v-row>
          <v-row
            justify="center">
            <v-col
              cols="auto">
              <v-btn
                rounded
                outlined
                color="primary"
                @click="toProfileSetting">OK</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-top-password-reset-dialog
      v-model="passwordDialog"
      :error="passwordError"
      @submit-button-click="sendResetMail"/>
    <v-dialog
      :value="!verified"
      width=350>
      <v-card>
        <v-container
          fluid>
          <v-row
            justify="center"
            >
            <v-col>
              メールアドレスの確認が完了していません。<br>
              確認メールを再送信しますか。
            </v-col>
          </v-row>
          <v-row
            justify="space-around">
            <v-col
              cols=auto>
              <v-btn
                rounded
                outlined
                @click="verified=true"
                >閉じる
              </v-btn>
            </v-col>
            <v-col
              cols=auto>
              <v-btn
                rounded
                outlined
                @click="resendVerifyMail">
                再送信
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-progress
      v-model="inProgress"
      :message="'ログインしています'"
      />
  </div>
</template>

<script>
import { auth } from '@/auth/client/firebase'
import { firestore } from "@/repository/client/firestore.js"
import { AuthService } from "@/service/auth/auth"
import VTopPasswordResetDialog from "@/components/organisms/parent/VTopPasswordResetDialog.vue"
import VProgress from '@/components/organisms/VProgress.vue'

export default {
  components: {
    VTopPasswordResetDialog,
    VProgress
  },
  data() {
    return {
      email: "",
      password: "",
      dialog: false,
      errorMessage: "",
      passwordDialog: false,
      passwordError: "",
      verified: true,
      inProgress: false
    }
  },
  methods: {
    async main() {
      this.$validator.validateAll().then(async result => {
        if (result) {
          await this.signIn()
        }
      })
    },
    async signIn () {
      this.inProgress = true
      try {
        const parent = await this.authService.signInAsParent(this.email, this.password)
        if (parent) {
          this.inProgress = false
          this.$store.commit("loginAsParent", parent)
          this.$router.push({
            name: "parentEditors",
            params: { id: parent.uuid }
          })
        } else {
          this.dialog = true
        }
      } catch(e) {
        this.inProgress = false
        if (e.name === 'UserUnVerifiedError') {
          this.verified = false
        } else {
          this.errorMessage = e.message
        }
      }
    },
    toProfileSetting() {
      this.dialog = false
      this.$router.push({name: 'parentProfileSetting'})
    },
    async sendResetMail(email) {
      try {
        const result = await this.authService.sendPasswordResetMail(email)
        this.passwordDialog = false
      } catch(e) {
        this.passwordError = e.message
      }
    },
    async resendVerifyMail() {
      this.authService.sendVerifyMail(process.env.VUE_APP_PARENT_SIGNUPED_URL)
      this.verified = true
    }
  },
  created: function() {
    this.authService = new AuthService(auth, firestore)
  }
}
</script>


<style scoped>
.clickable--text {
  display: inline-block;
  text-decoration-line: underline;
  padding: 2px;
  border-radius: 3px;
  cursor: pointer;
}

.clickable--text:hover {
  color:azure;
  background-color: rgb(226, 223, 223);
}

</style>
